// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"828d2851","488":"7cba0d64"}[chunkId] + ".chunk.js";
};